import { useState } from "react";
import { supabase, staffLogin } from "@/lib/supabase";

type Mode = "admin" | "staff";

export function Login() {
  const [mode, setMode] = useState<Mode>("admin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [magicSent, setMagicSent] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function loginPassword(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) setErr(error.message);
  }

  async function loginMagic() {
    setErr(null);
    setLoading(true);
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: window.location.origin + "/" },
    });
    setLoading(false);
    if (error) setErr(error.message);
    else setMagicSent(true);
  }

  async function loginStaff(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      await staffLogin(code);
      // onAuthStateChange in App neemt het over → afgeslankte medewerker-weergave
    } catch (er) {
      setErr(er instanceof Error ? er.message : String(er));
    } finally {
      setLoading(false);
    }
  }

  function switchMode(m: Mode) {
    setMode(m);
    setErr(null);
  }

  return (
    <div className="login-shell">
      <div className="login-card">
        <h1>Haringparty Admin</h1>

        <div className="tabs" style={{ marginBottom: "1.2rem" }}>
          <button type="button" className={`tab ${mode === "admin" ? "active" : ""}`} onClick={() => switchMode("admin")}>
            Beheerder
          </button>
          <button type="button" className={`tab ${mode === "staff" ? "active" : ""}`} onClick={() => switchMode("staff")}>
            Medewerker (code)
          </button>
        </div>

        {mode === "staff" ? (
          <form onSubmit={loginStaff}>
            <p style={{ marginTop: 0 }}>Voer de 4-cijferige deurcode in om te scannen en de lijsten te bekijken.</p>
            <div className="field">
              <input
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                pattern="[0-9]*"
                maxLength={4}
                placeholder="● ● ● ●"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 4))}
                autoFocus
                style={{ textAlign: "center", letterSpacing: "0.5em", fontSize: "1.4rem", fontFamily: "var(--f-mono)" }}
              />
            </div>
            <button className="btn-admin" type="submit" disabled={loading || code.length !== 4} style={{ width: "100%" }}>
              {loading ? "Bezig..." : "→ Toegang"}
            </button>
            <div style={{ marginTop: "1rem", fontSize: "0.78rem", color: "rgba(255,244,214,0.55)", lineHeight: 1.5 }}>
              Met de code kun je scannen, de ticket-deurlijst en de ambassadeurs inzien en downloaden — geen omzet of bestellingen.
            </div>
            {err && <div style={{ color: "#fda4af", marginTop: "1rem", fontSize: "0.85rem" }}>{err}</div>}
          </form>
        ) : magicSent ? (
          <div style={{ padding: "1.5rem", border: "1px dashed var(--c-orange)", color: "var(--c-cream)", fontFamily: "var(--f-mono)", fontSize: "0.85rem" }}>
            ✓ Magic link verstuurd naar <strong>{email}</strong>.<br />
            Open de link op dit apparaat om in te loggen.
          </div>
        ) : (
          <form onSubmit={loginPassword}>
            <div className="field">
              <input
                type="email"
                placeholder="info@odeaandeharing.nl"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                autoComplete="username"
              />
            </div>
            <div className="field">
              <input
                type="password"
                placeholder="Wachtwoord"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>
            <button className="btn-admin" type="submit" disabled={loading || !email || !password} style={{ width: "100%" }}>
              {loading ? "Bezig..." : "Inloggen"}
            </button>

            <div style={{ marginTop: "1rem", paddingTop: "1rem", borderTop: "1px dashed rgba(255,122,26,0.3)", fontSize: "0.8rem", color: "rgba(255,244,214,0.6)" }}>
              Wachtwoord vergeten?{" "}
              <button
                type="button"
                onClick={loginMagic}
                disabled={!email || loading}
                style={{ background: "none", border: "none", color: "var(--c-orange)", cursor: "pointer", textDecoration: "underline", padding: 0, fontSize: "0.8rem" }}
              >
                Stuur magic link
              </button>
            </div>

            {err && <div style={{ color: "#fda4af", marginTop: "1rem", fontSize: "0.85rem" }}>{err}</div>}
          </form>
        )}
      </div>
    </div>
  );
}
